module.exports = __webpack_public_path__ + "img/ico_val.2c0951a2.png";